package com.macrofocus.eflux.components

import com.macrofocus.eflux.Sizes
import com.macrofocus.eflux.theme.ThemeContext
import mui.system.Box
import mui.system.sx
import react.FC
import react.Props
import react.use
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.px

val SidebarContent = FC<Props> {
    val DEBUG = false

    val diviso = use(EFluxContext)!!
    var theme by use(ThemeContext)!!

    Box {
        sx {
            width = Sizes.Sidebar.Width
            display = Display.inlineFlex
            justifyContent = JustifyContent.center

            marginTop = 50.px
        }

//        Logo {
////                sx { width = Sizes.Sidebar.Width }
//
//            version = BuildKonfig.efluxVersion
//            logo = if (theme.palette.mode == PaletteMode.light) "/swissgrid-247.svg" else "/swissgrid-247-negativ.svg"
//            height = 54.0
//            marginLeft = -12.px
//            onClick = {
//                diviso.dataLoader.currentViewLoader?.svgPanZoomContext?.value?.reset()
//                diviso.configuration.timeTracker.liveTurnedOn()
//                diviso.configuration.pointProbing.clearSelection()
//                diviso.configuration.pathProbing.clearSelection()
//                diviso.configuration.pointSelection.clearSelection()
//                diviso.configuration.pathSelection.clearSelection()
//            }
//        }
    }

//    Box {
//        sx {
//            display = Display.inlineFlex
//            marginLeft = 10.px
//        }
//
//        LiveSwitch {
//            timeTracker = diviso.configuration.timeTracker
//            badge = false
//        }
//
//        DateChooser {
//            timeTracker = diviso.configuration.timeTracker
//        }
//    }

//    Box {
//        sx {
//            width = 100.pct
//            height = 200.px
//        }
//
//        Info {
//
//        }
//    }
//
//    Box {
//        sx {
//            display = Display.inlineFlex
//            marginLeft = 10.px
//        }
//
//        TimeSlider {
//            timeTracker = diviso.configuration.timeTracker
//            timeUnitChooser = false
//            valueLabelDisplay = "off"
//            width = 210.px
//        }
//    }
}